import { render, staticRenderFns } from "./TemplateDataGrid.vue?vue&type=template&id=8c7d7a2c"
import script from "./TemplateDataGrid.vue?vue&type=script&lang=js"
export * from "./TemplateDataGrid.vue?vue&type=script&lang=js"
import style0 from "./TemplateDataGrid.vue?vue&type=style&index=0&id=8c7d7a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports